import { handleActions } from 'redux-actions';

import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';
import getCRUDSagas from '../../utils/redux/getCRUDSagas';

import * as commonActionHandlers from '../../utils/redux/commonActionHandlers';

import Api from '../../utils/resourcesApi';

// The list of recurring templates (FIN-1266) — the plain CRUD feature. The
// TEMPLATE itself is a page of its own (./Template), which reads its data
// straight from the resource, like the Master Account month does.
export const constants = getConstantsByFeatureName('RECURRING_TEMPLATES');

export const actions = getActionCreators(constants);

const initialState = { ...commonActionHandlers.initialState };

export const reducer = handleActions(getActionHandlers(constants), initialState);

export const selector = getSelectorByFeatureName('recurringTemplates');

export const sagas = getCRUDSagas(
  '/recurring_templates',
  Api.recurringTemplates,
  actions,
  constants,
  'recurringTemplates',
  'recurringTemplates',
);
